(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('securityStackReportsLinksConverter', ["$q", "$injector", "feature", "configDao", "cpUiFunctions", "brandInfo", function ($q, $injector, feature, configDao, cpUiFunctions, brandInfo) {
        function makeLink(links, label) {
            if (!links || !links.length) {
                if (label && typeof label === 'object') {
                    return '#' + JSON.stringify({
                        text: label.text,
                        'class': 'single-report-link blocked',
                        tooltip: label.tooltip
                    });
                }
                return '#' + JSON.stringify({
                    text: 'Execution report not available',
                    'class': 'single-report-link blocked'
                });
            }
            if (links.length === 1) {
                return '#' + JSON.stringify({
                    display: 'external-link',
                    href: links[0].href,
                    text: (label || 'View') + ' Report',
                    'class': 'single-report-link'
                });
            }
            return '#' + JSON.stringify({
                display: 'inline-list',
                data: _(links).map(function (linkInfo) {
                    return '#' + JSON.stringify({
                        display: 'external-link',
                        text: linkInfo.label,
                        href: linkInfo.href,
                        tooltip: linkInfo.label
                    });
                }),
                'class': 'pdf-reports-links-container',
                countText: (label || 'View PDF') + ' Reports'
            });
        }
        return function (input, args) {
            if (input.data.wildfire && input.data.wildfire.sha256) {
                input.data.wildfire.pdfReportsLinks = makeLink([{ href: '/api/v1/wildfire/pdf_report/' + input.data.wildfire.sha256 }]);
            }
            if (input.data.solgate && input.data.solgate.have_word_report) {
                input.data.solgate.pdfReportsLinks = makeLink([{ href: '/api/v1/solgate/report/' + args.entityType + '/' + args.fileId }], 'Download Word');
            }
            if (input.data.av_cisco && input.data.av_cisco.have_pdf_report) {
                input.data.av_cisco.pdfReportsLinks = makeLink([{ href: '/api/v1/av_cisco/report/' + args.entityType + '/' + args.fileId }]);
            }
            if (input.data.atp_fireeye && input.data.atp_fireeye.have_report) {
                input.data.atp_fireeye.pdfReportsLinks = makeLink([{ href: '/api/v1/atp_fireeye/' + args.entityType + '/' + args.fileId }], 'View HTML');
            }
            if (input.data.lastline_av_file) {
                if (input.data.lastline_av_file.have_pdf_report) {
                    input.data.lastline_av_file.pdfReportsLinks = makeLink([{ href: '/api/v1/lastline_av/report/lastline_av_file/' + args.entityType + '/' + args.fileId }]);
                } else {
                    input.data.lastline_av_file.pdfReportsLinks = makeLink(null, {
                        text: 'No Report',
                        tooltip: 'The file does not include active content'
                    });
                }
            }
            if (input.data.lastline_te) {
                if (input.data.lastline_te.task_uuid) {
                    input.data.lastline_te.pdfReportsLinks = makeLink([{ href: '/api/v1/external_sectool/report/lastline_te/' + args.entityType + '/' + args.fileId }]);
                } else {
                    input.data.lastline_te.pdfReportsLinks = makeLink(null, {
                        text: 'No Report',
                        tooltip: 'The file does not include active content'
                    });
                }
            }
            if (input.data.lastline_av_hash && input.data.lastline_av_hash.have_pdf_report) {
                input.data.lastline_av_hash.pdfReportsLinks = makeLink([{ href: '/api/v1/lastline_av/report/lastline_av_hash/' + args.entityType + '/' + args.fileId }]);
            }
            if (input.data.av_sonicwall && input.data.av_sonicwall.status_code !== 'mime_type_not_supported') {
                if (feature.sonicwallTheme && input.data.av_sonicwall.task_id) {
                    return $q.allSettled([
                        configDao.param('sonicwall_captureatp_fqdn'),
                        configDao.param('sonicwall_serial_number'),
                        configDao.param('sonicwall_captureatp_key')
                    ]).then(function (responses) {
                        if (responses[0].value && responses[1].value && responses[2].value) {
                            var swLink = 'https://' + responses[0].value + '/atp/reportatp.html' + '?taskid=' + input.data.av_sonicwall.task_id + '&sn=' + responses[1].value + '&key=' + responses[2].value + '&env=utm&locale=en';
                            input.data.av_sonicwall.htmlReportsLinks = makeLink([{ href: swLink }]);
                        } else {
                            input.data.av_sonicwall.pdfReportsLinks = makeLink();
                        }
                        return $q.when(input);
                    });
                } else {
                    input.data.av_sonicwall.pdfReportsLinks = makeLink();
                }
            }
            if (input.data.checkpoint_te) {
                var api = '';
                var fileDao = $injector.get('fileDao');
                var summaryReport = input.data.checkpoint_te.raw_res && input.data.checkpoint_te.raw_res.te && input.data.checkpoint_te.raw_res.te.summary_report;
                var combinedVerdict = input.data.checkpoint_te.raw_res && input.data.checkpoint_te.raw_res.te && input.data.checkpoint_te.raw_res.te.combined_verdict;
                return fileDao.checkpointTePdfReports(args.fileId, args.entityType).then(function (response) {
                    if (feature.checkpointTheme) {
                        if (summaryReport) {
                            api = '/api/v1/checkpoint/summary_report/' + args.entityType + '/' + args.fileId + '/' + summaryReport + '/ThreatEmulationReport.html';
                            input.data.checkpoint_te.htmlReportsLinks = makeLink([{ href: cpUiFunctions.createCPLoadPageUrl(brandInfo.getPortalUrl('cp'), api) }], 'View');
                        } else if (response.data && !_.isEmpty(response.data.images)) {
                            input.data.checkpoint_te.pdfReportsLinks = makeLink(_(response.data.images).map(function (label, imageId) {
                                api = '/api/v1/checkpoint/pdf_report/' + args.entityType + '/' + args.fileId + '/' + imageId;
                                return {
                                    href: cpUiFunctions.createCPLoadPageUrl(brandInfo.getPortalUrl('cp'), api),
                                    label: label
                                };
                            }));
                        } else if (combinedVerdict != 'benign') {
                            input.data.checkpoint_te.pdfReportsLinks = makeLink([]);
                        }
                        return $q.when(input);
                    } else {
                        if (summaryReport) {
                            api = '/api/v1/checkpoint/summary_report/' + args.entityType + '/' + args.fileId + '/' + summaryReport + '/ThreatEmulationReport.html';
                            input.data.checkpoint_te.htmlReportsLinks = makeLink([{ href: api }], 'View');
                        } else if (response.data && !_.isEmpty(response.data.images)) {
                            input.data.checkpoint_te.pdfReportsLinks = makeLink(_(response.data.images).map(function (label, imageId) {
                                api = '/api/v1/checkpoint/pdf_report/' + args.entityType + '/' + args.fileId + '/' + imageId;
                                return {
                                    href: api,
                                    label: label
                                };
                            }));
                        } else if (combinedVerdict != 'benign') {
                            input.data.checkpoint_te.pdfReportsLinks = makeLink([]);
                        }
                    }
                    return $q.when(input);
                });
            }
            return $q.when(input);
        };
    }]);
}());